module.exports = __webpack_public_path__ + "static/media/ico_btn_inter.3cc89b0a.svg";